import styled, { css } from 'styled-components'
import { icons } from 'common'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .asset_menu {
    width: 100%;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .asset_menu .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  }
  .asset_menu .select-box {
    position: relative;
    display: block;
    font-weight: 300;
    width: 100%;
    border-radius: 5px;
    white-space: nowrap;
  }
  .asset_menu .select-box__current {
    position: relative;
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
  }
  .asset_menu .select-box__input + .select-box__input-text:hover {
    background: hsl(218, 23%, 25%);
  }
  .asset_menu .select-box__input:checked + .select-box__input-text:hover {
    background: transparent;
  }
  .asset_menu .select-box__current:focus .menu_select {
    transform: translateY(-50%) rotate(0);
  }
  .asset_menu .menu_select {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%) rotate(180deg);
    width: 20px;
    opacity: 1;
    transition: 0.5s ease;
  }
  .asset_menu .select-box__value {
    display: flex;
  }
  .asset_menu .select-box__input {
    display: none;
  }
  .asset_menu .select-box__input:checked + .select-box__input-text {
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    width: calc(100% - 25px);
    justify-content: space-between;
  }
  .asset_menu .select-box__input-text {
    display: none;
    border-radius: 10px;
  }
  .asset_menu .select-box__input-text img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 0;
  }
  .asset_menu .select-box__input-text .single_asset_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin: 0 30px 0 0;
  }
  .asset_menu .select-box__input-text .tfh_change {
    font-size: 0.75rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin: 2px 25px 0 0;
  }
  .asset_menu .select-box__input-text .tfh_change.down {
    color: var(--site-result-lost-color);
  }
  .asset_menu .select-box__input-text .tfh_change.up {
    color: var(--site-result-won-color);
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/gameplay.css */
  .game_header.iw {
    height: 80px;
    margin-top: 20px;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .game_header.iw .asset_display {
    background: hsla(0, 0%, 100%, 0.1);
    height: fit-content;
    border-radius: 10px;
    line-height: 100%;
    padding: 10px 15px;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin: 0 10px 0 0;
  }
  .current_price_display {
    border-radius: 10px;
    line-height: 100%;
    padding: 10px 14px 10px 10px;
    height: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .current_price_display label {
    font-size: 1.5rem;
    font-weight: 500;
    letter-spacing: -0.02em;
  }
  .price_direction_icon {
    -webkit-mask: url(${icons.bid_direction_icon}) center center / auto 18px no-repeat;
    mask: url(${icons.bid_direction_icon}) center center / auto 18px no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 3px 0 0;
  }
  .current_price_display.down {
    background: hsl(342, 28%, 16%);
  }
  .current_price_display.down label {
    color: var(--site-result-lost-color);
  }
  .price_direction_icon.down {
    background: var(--site-result-lost-color);
    transform: rotate(0deg);
  }
  .current_price_display.up {
    background: hsl(342, 28%, 16%);
  }
  .current_price_display.up label {
    color: var(--site-result-won-color);
  }
  .price_direction_icon.up {
    background: var(--site-result-won-color);
    transform: rotate(0deg);
  }
  @media (max-width: 600px) {
    .game_header.iw {
      width: 100%;
      margin-top: 0;
      height: auto;
    }
    .game_header.iw .asset_display {
      padding: 10px;
      margin-right: 5px;
    }
    .asset_menu .select-box__input:checked + .select-box__input-text {
      font-size: 0.9rem;
      width: calc(100% - 25px);
    }
    .asset_menu .select-box__input-text .single_asset_wrapper {
      margin: 0 10px 0 0;
    }
    .current_price_display {
      padding: 10px;
      width: 100%;
      border-radius: 0;
    }
    .current_price_display label {
      font-size: 1.1rem;
      letter-spacing: -0.02em;
    }
    .price_direction_icon {
      width: 16px;
      height: 16px;
      -webkit-mask-size: auto 16px;
      mask-size: auto 16px;
      margin-right: 2px;
    }
    .asset_menu .select-box__input-text img {
      width: 18px;
      height: 18px;
      margin: 0 4px 0 0;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/roi_calc_modal.css */
  /* .menu_select {
    width: 18px;
    height: 18px;
    background: hsla(0, 0%, 0%, 0.2) url(${icons.arrow_up}) center 4px / auto 9px no-repeat;
    filter: invert(1);
    border-radius: 3px;
    cursor: pointer;
  } */
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  @media (max-width: 800px) {
    .game_header.iw .current_price_display label {
      font-size: 1.4rem;
      letter-spacing: -0.03em;
    }
    .game_header.iw .current_price_display .price_direction_icon {
      -webkit-mask: url(${icons.bid_direction_icon}) center center / auto 14px no-repeat;
      mask: url(${icons.bid_direction_icon}) center center / auto 14px no-repeat;
      width: 14px;
      height: 14px;
      margin: 0 5px 0 0;
    }
  }
`
const devCSS = css`
  .select-box div.assets_pad {
    position: absolute;
    margin-top: 20px;
    left: -15px;
    width: calc(100% + 15px + 15px);
  }

  .select-box div.assets_pad.close {
    opacity: 0;
  }
  .select-box div.assets_pad.open {
    opacity: 1;
  }
`

export const LvgAssetHeaderCSS = styled.div`
  ${designerCSS}
  ${devCSS}
`
